module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/svg-icons/Badges/Payments/Bancontact-8d304ac7d38ef4b7a77fa606a83b9bf7.svg";